// LanguagesSection.js
import React, { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import "./LanguagesSection.css";

export default function LanguagesSection() {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) return;
  
    // already loaded?
    if (window.Tally) return;
    if (document.querySelector('script[src="https://tally.so/widgets/embed.js"]')) return;
  
    const s = document.createElement("script");
    s.src = "https://tally.so/widgets/embed.js";
    s.async = true;
    document.head.appendChild(s);
  }, []);
  return (
    <section className="langSection" aria-labelledby="lang-title">
      <div className="langContainer">
        <header className="langHeader">
          <h2 id="lang-title" className="langTitle">
          Qual idioma você quer aprender?
          </h2>
          {/* <p className="langSubtitle">
            Escolha sua jornada. Comece com nossa biblioteca completa de Alemão ou
            aguarde: mais idiomas chegam em breve.
          </p> */}
        </header>

        <div className="langGrid" role="list" aria-label="Idiomas disponíveis e em breve">
          {/* German - Available */}
          <div className="langCard langCard--featured" role="listitem" aria-label="Alemão disponível">
            <div className="langPill langPill--available">
              <span className="langPillIcon" aria-hidden="true">✓</span>
              Disponível
            </div>

            <div className="langFlag" aria-hidden="true">🇩🇪</div>

            <div className="langCardBody">
              <div className="langName">Alemão</div>
              <div className="langMeta">50+ histórias • Todos os níveis</div>
            </div>
          </div>

          {/* English - Coming Soon */}
          <div className="langCard" role="listitem" aria-label="Inglês em breve">
            <div className="langPill langPill--soon">
              <span className="langPillIcon" aria-hidden="true">🕒</span>
              Em breve
            </div>

            <div className="langFlag" aria-hidden="true">🇺🇸</div>

            <div className="langCardBody">
              <div className="langName">Inglês</div>
              <div className="langMeta">Histórias em desenvolvimento</div>
            </div>
          </div>

          {/* Spanish - Coming Soon */}
          <div className="langCard" role="listitem" aria-label="Espanhol em breve">
            <div className="langPill langPill--soon">
              <span className="langPillIcon" aria-hidden="true">🕒</span>
              Em breve
            </div>

            <div className="langFlag" aria-hidden="true">🇪🇸</div>

            <div className="langCardBody">
              <div className="langName">Espanhol</div>
              <div className="langMeta">Histórias em desenvolvimento</div>
            </div>
          </div>

          {/* More languages */}
          <div className="langCard langCard--dashed" role="listitem" aria-label="Mais idiomas em breve">
            <div className="langPill langPill--later">
                <span className="langPillIcon" aria-hidden="true">⏳</span>
                No futuro
              </div>

            <div className="langFlag" aria-hidden="true">+</div>

            <div className="langCardBody">
              <div className="langName">Outros</div>
              <div className="langMeta">
                Francês, Italiano, e outros chegando depois
              </div>
            </div>
          </div>
        </div>
        <p className="coming-soon__value">
        Seja avisado quando novos idiomas chegarem.
        </p>
        <button
          className="notify-language-btn"
          data-tally-open="mYN7Dz"
          data-tally-layout="modal"
          data-tally-hide-title="1"
          onClick={() => {
            if (!window.Tally) window.open("https://tally.so/r/mYN7Dz", "_blank", "noopener,noreferrer");
          }}
        >
          Seja notificado 🔔
        </button>
      </div>
    </section>
  );
}
